import { matchPath, useLocation } from "react-router";

const defaultValue = {
  routes: [""]
};

export const useShowComponentByRoutes = ({ routes } = defaultValue) => {
  const { pathname } = useLocation();
  const isRouteWithRegex = (route) =>
    String(route).match(/\[/) && pathname.match(route);
  const routeHasAccess = (route) =>
    matchPath(route, pathname) || isRouteWithRegex(route);

  return {
    isVisible: routes.some((item) => routeHasAccess(item))
  };
};
